import request from '@/utils/request'
export function getRankingData(findRequest) {
  return request({
    url: '/maps/GetRankingData',
    method: 'post',
    data: findRequest,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
